import { Grid } from "@mui/material";
import { DebFormTextInput } from "../components/DebFormComponents";

//[Microservicio Mobile] Archivo de especificaciones para cada Proveedor disponible, según el tipo de canal.

const FormGenerator = ({ config }) => {
    return (
      <Grid container sx={{ pt: 3 }} spacing={2}>
        {config.map(({name, label, placeholder}) => (
          <Grid item xs={6} key={name}>
            <DebFormTextInput label={label} name={name} placeholder={placeholder} variant="filled" />
          </Grid>
        ))}
      </Grid>
    );
  };

  //INITIAL VALUES GENERATOR
  function generateInitialObject(entries) {
    const initialObject = {};
  
    entries.forEach(({ name }) => {
      initialObject[name] = "";
    });
  
    return initialObject;
  }

    //EMAIL.movistar
        //Modal
    const entriesEMAILmovistar = [
        {name: "urlEMAILmovistar", label: "url", placeholder: "URL del servicio de movistar"},
        {name: "templateSurveyEMAILmovistar", label: "templateSurvey", placeholder: ""},
        {name: "descriptionEMAILmovistar", label: "description", placeholder: ""},
    ];
    export const EMAILmovistar = <FormGenerator config={entriesEMAILmovistar} />;
        //Condiciones iniciales
    export const initialEMAILmovistar = generateInitialObject(entriesEMAILmovistar);
    

    //EMAIL.smtp
    const entriesEMAILsmtp = [
        {name: "friendlyNameEMAILsmtp", label: "friendlyName", placeholder: ""},
        {name: "fromEMAILsmtp", label: "from", placeholder: "Email de origen"},
        {name: "userEMAILsmtp", label: "user", placeholder: ""},
        {name: "passwordEMAILsmtp", label: "password", placeholder: ""},
        {name: "hostEMAILsmtp", label: "host", placeholder: ""},
        {name: "portEMAILsmtp", label: "port", placeholder: ""},
        {name: "sslEMAILsmtp", label: "ssl", placeholder: ""},
        {name: "tlsEMAILsmtp", label: "tls", placeholder: ""},
        {name: "tlsProtocolEMAILsmtp", label: "tlsProtocol", placeholder: ""},
        {name: "authEnabledEMAILsmtp", label: "authEnabledEMAILsmtp", placeholder: ""},
        {name: "emailParserStrategyEMAILsmtp", label: "emailParserStrategy", placeholder: ""},
        {name: "eventsEnabledEMAILsmtp", label: "eventsEnabled", placeholder: "true/false (vacío es 'true')"},
        {name: "descriptionEMAILsmtp", label: "description", placeholder: ""},
    ];

    export const EMAILsmtp = <FormGenerator config={entriesEMAILsmtp} />;
    export const initialEMAILsmtp = generateInitialObject(entriesEMAILsmtp)

    
    //EMAIL.telefonica
    const entriesEMAILtelefonica = [
        {name: "templateSurveyEMAILtelefonica", label: "templateSurvey", placeholder: ""},
        {name: "templateEmailEMAILtelefonica", label: "templateEmail", placeholder: ""},
        {name: "descriptionEMAILtelefonica", label: "description", placeholder: ""},
    ];
    export const EMAILtelefonica = <FormGenerator config={entriesEMAILtelefonica} />;
    export const initialEMAILtelefonica = generateInitialObject(entriesEMAILtelefonica);


    //SMS.bitsense y SMS_REMINDER.bitsense
    const entriesSMSbitsense = [
        {name: "tokenSMSbitsense", label: "token", placeholder: "Token (desde la web de bitsense)"},
        {name: "campaingSMSbitsense", label: "campaing", placeholder: "Id de la campaña sms"},
        {name: "countrySMSbitsense", label: "country", placeholder: "País"},
        {name: "regionSMSbitsense", label: "region", placeholder: "Región"},
        {name: "descriptionSMSbitsense", label: "description", placeholder: ""},
    ];
    export const SMSbitsense = <FormGenerator config={entriesSMSbitsense} />;
    export const initialSMSbitsense = generateInitialObject(entriesSMSbitsense);


    //SMS.c3ntro y SMS_REMINDER.c3ntro
    const entriesSMSc3ntro = [
        {name: "urlSMSc3ntro", label: "url", placeholder: "URL para envio de SMS"},
        {name: "usernameSMSc3ntro", label: "username", placeholder: "usuarioProveedor"},
        {name: "passwordSMSc3ntro", label: "password", placeholder: "*****"},
        {name: "prefijoSMSc3ntro", label: "prefijo", placeholder: "Prefijo de número internacional sin el "+" (Ej: 1 para EEUU)"},
        {name: "descriptionSMSc3ntro", label: "description", placeholder: ""},
    ];
    export const SMSc3ntro = <FormGenerator config={entriesSMSc3ntro} />;
    export const initialSMSc3ntro = generateInitialObject(entriesSMSc3ntro);


    //SMS.davivienda y SMS_REMINDER.davivienda
    const entriesSMSdavivienda = [
        {name: "urlSMSdavivienda", label: "url", placeholder: "URL para envio de SMS"},
        {name: "templateSMSdavivienda", label: "template", placeholder: ""},
        {name: "timeoutSMSdavivienda", label: "timeout", placeholder: "Tiempo de espera"},
        {name: "codMonedaSMSdavivienda", label: "codMoneda", placeholder: "Código de moneda"},
        {name: "codPaisSMSdavivienda", label: "codPais", placeholder: "Código de país"},
        {name: "codIdiomaSMSdavivienda", label: "codIdioma", placeholder: "Código de idioma"},
        {name: "idCanalSMSdavivienda", label: "idCanal", placeholder: "Id del canal"},
        {name: "idConsumidorSMSdavivienda", label: "idConsumidor", placeholder: "Id del consumidor"},
        {name: "idAplicaionSMSdavivienda", label: "idAplicaion", placeholder: "Id de la aplicación"},
        {name: "idHostSMSdavivienda", label: "idHost", placeholder: "Id del host"},
        {name: "idTerminalSMSdavivienda", label: "idTerminal", placeholder: "Id del terminal"},
        {name: "tipoNotificacionSMSdavivienda", label: "tipoNotificacion", placeholder: "Identificador del tipo de notificación a enviar"},
        {name: "keystore_formatSMSdavivienda", label: "keystore_format", placeholder: "PKCS12"},
        {name: "keystore_pathSMSdavivienda", label: "keystore_path", placeholder: "usr/lib/jvm/jdk1.8.0_201/jre/lib/security/alianza.pfx"},
        {name: "keystore_passSMSdavivienda", label: "keystore_pass", placeholder: "FsEjBdij3v6z5t/K"},
        {name: "keystore_aliasSMSdavivienda", label: "keystore_alias", placeholder: "alianza.debmedia.lab"},
        {name: "descriptionSMSdavivienda", label: "description", placeholder: ""},
    ];
    export const SMSdavivienda = <FormGenerator config={entriesSMSdavivienda} />;
    export const initialSMSdavivienda = generateInitialObject(entriesSMSdavivienda);


    //SMS.mobisa y SMS_REMINDER.mobisa
    const entriesSMSmobisa = [
        {name: "urlAWS_SMSmobisa", label: "urlAWS", placeholder: "URL de API Gateway de AWS"},
        {name: "apiKeyAWS_SMSmobisa", label: "apiKeyAWS", placeholder: "x-api-key de AWS"},
        {name: "urlMobisaSMSmobisa", label: "urlMobisa", placeholder: "http://api.dinama.com/services/messages"},
        {name: "timeoutSMSmobisa", label: "timeout", placeholder: "Timeout para el llamado a los servicios de Mobisa"},
        {name: "serviceSID_SMSmobisa", label: "serviceSID", placeholder: "serviceSID otorgado por Mobisa"},
        {name: "apiKeyMobisaSMSmobisa", label: "apiKeyMobisa", placeholder: "Api-Key otorgado por Mobisa"},
        {name: "countryCodSMSmobisa", label: "countryCod", placeholder: "Valor otorgado por Mobisa ('pr' para Puerto Rico)"},
        {name: "prefijoSMSmobisa", label: "prefijo", placeholder: "Prefijo de número internacional sin el '+' (Ej: 1, para EEUU)"},
        {name: "descriptionSMSmobisa", label: "description", placeholder: ""},
    ];
    export const SMSmobisa = <FormGenerator config={entriesSMSmobisa} />;
    export const initialSMSmobisa = generateInitialObject(entriesSMSmobisa);


    //SMS.movistar y SMS_REMINDER.movistar
    const entriesSMSmovistar = [
        {name: "urlSMSmovistar", label: "url", placeholder: "URL del servicio de movistar"},
        {name: "templateSurveySMSmovistar", label: "templateSurvey", placeholder: ""},
        {name: "descriptionSMSmovistar", label: "description", placeholder: ""},
    ];
    export const SMSmovistar = <FormGenerator config={entriesSMSmovistar} />;
    export const initialSMSmovistar = generateInitialObject(entriesSMSmovistar);


    //SMS.supervielle y SMS_REMINDER.supervielle
    const entriesSMSsupervielle = [
        {name: "urlSMSsupervielle", label: "url", placeholder: "URL del servicio de Supervielle"},
        {name: "timeoutSMSsupervielle", label: "timeout", placeholder: "Tiempo de espera"},
        {name: "templateSMSsupervielle", label: "template", placeholder: ""},
        {name: "cellCompaniesSMSsupervielle", label: "cellCompanies", placeholder: "Configuración de los códigos de compañía"},
        {name: "descriptionSMSsupervielle", label: "description", placeholder: ""}
    ];
    export const SMSsupervielle = <FormGenerator config={entriesSMSsupervielle} />;
    export const initialSMSsupervielle = generateInitialObject(entriesSMSsupervielle);


    //SMS.telefonica y SMS_REMINDER.telefonica
    const entriesSMStelefonica = [
        {name: "headerInSMStelefonica", label: "headerIn", placeholder: ""},
        {name: "descriptionSMStelefonica", label: "description", placeholder: ""}
    ];
    export const SMStelefonica = <FormGenerator config={entriesSMStelefonica} />;
    export const initialSMStelefonica = generateInitialObject(entriesSMStelefonica);


    //SMS.twilio y SMS_REMINDER.twilio
    const entriesSMStwilio = [
        {name: "accountSidSMStwilio", label: "accountSid", placeholder: ""},
        {name: "authTokenSMStwilio", label: "authToken", placeholder: "Token de autenticación"},
        {name: "fromNumberSMStwilio", label: "fromNumber", placeholder: "Número de origen"},
        {name: "countryCodeSMStwilio", label: "countryCode", placeholder: "Código de pais"},
        {name: "descriptionSMStwilio", label: "description", placeholder: ""} 
    ];
    export const SMStwilio = <FormGenerator config={entriesSMStwilio} />;
    export const initialSMStwilio = generateInitialObject(entriesSMStwilio);
   

    //WHATSAPP.vonage
    const entriesWHATSAPPvonage = [
        {name: "regionWHATSAPPvonage", label: "region", placeholder: "+54"},
        {name: "vonagePhoneNumberWHATSAPPvonage", label: "vonageNumber", placeholder: "Número de tel. vonage (Ej: 541143218765)"},
        {name: "namespaceWHATSAPPvonage", label: "namespace", placeholder: "66fe1c4b_abf6_4346_b55f_76bba4a9d471"},
        {name: "defaultTemplateEnvWHATSAPPvonage", label: "defaultTemplateEnv", placeholder: "Templates defaults CLIENTS/DEBQ2"},
        {name: "wabaIdWHATSAPPvonage", label: "wabaId", placeholder: "Whatsapp Business Id"},
        {name: "languageWHATSAPPvonage", label: "language", placeholder: "Idioma de los templates (es-AR o pt-BR)"},
        {name: "descriptionWHATSAPPvonage", label: "description", placeholder: ""},
    ];
    export const WHATSAPPvonage = <FormGenerator config={entriesWHATSAPPvonage} />;
    export const initialWHATSAPPvonage = generateInitialObject(entriesWHATSAPPvonage);

    
//INITIAL VALUES
export const cleanInitialProvider = {
    ...initialEMAILmovistar,
    ...initialEMAILsmtp,
    ...initialEMAILtelefonica,
    ...initialSMSbitsense,
    ...initialSMSc3ntro,
    ...initialSMSdavivienda,
    ...initialSMSmobisa,
    ...initialSMSmovistar,
    ...initialSMSsupervielle,
    ...initialSMStelefonica,
    ...initialSMStwilio,
    ...initialWHATSAPPvonage
};

export const newProvider = {
    id: "",
    channel: "",
    provider: "",
    providerCompanies: [],
    ...cleanInitialProvider
    }


//ENUMS
export const channelTypes = {
    EMAIL: "EMAIL",
    SMS: "SMS",
    SMS_REMINDER: "SMS_REMINDER",
    WHATSAPP: "WHATSAPP"
};

export const providerConstants = {
    EMAIL_MOVISTAR: "EMAIL.movistar",
    EMAIL_SMTP: "EMAIL.smtp",
    EMAIL_TELEFONICA: "EMAIL.telefonica",
    SMS_BITSENSE: "SMS.bitsense",
    SMS_REMINDER_BITSENSE: "SMS_REMINDER.bitsense",
    SMS_C3NTRO: "SMS.c3ntro",
    SMS_REMINDER_C3NTRO: "SMS_REMINDER.c3ntro",
    SMS_DAVIVIENDA: "SMS.davivienda",
    SMS_REMINDER_DAVIVIENDA: "SMS_REMINDER.davivienda",
    SMS_MOBISA: "SMS.mobisa",
    SMS_REMINDER_MOBISA: "SMS_REMINDER.mobisa",
    SMS_MOVISTAR: "SMS.movistar",
    SMS_REMINDER_MOVISTAR: "SMS_REMINDER.movistar",
    SMS_SUPERVIELLE: "SMS.supervielle",
    SMS_REMINDER_SUPERVIELLE: "SMS_REMINDER.supervielle",
    SMS_TELEFONICA: "SMS.telefonica",
    SMS_REMINDER_TELEFONICA: "SMS_REMINDER.telefonica",
    SMS_TWILIO: "SMS.twilio",
    SMS_REMINDER_TWILIO: "SMS_REMINDER.twilio",
    WHATSAPP_VONAGE: "WHATSAPP.vonage"
};

export const providerCompaniesPerType = {
EMAIL: [
    { label: "Movistar", value: providerConstants.EMAIL_MOVISTAR  },
    { label: "SMTP", value: providerConstants.EMAIL_SMTP  },
    { label: "Telefónica", value: providerConstants.EMAIL_TELEFONICA  },
],
SMS: [
    { label: "Bitsense", value: providerConstants.SMS_BITSENSE },
    { label: "C3ntro", value: providerConstants.SMS_C3NTRO  },
    { label: "Davivienda", value: providerConstants.SMS_DAVIVIENDA  },
    { label: "Mobisa", value: providerConstants.SMS_MOBISA  },
    { label: "Movistar", value: providerConstants.SMS_MOVISTAR  },
    { label: "Supervielle", value: providerConstants.SMS_SUPERVIELLE  },
    { label: "Telefónica", value: providerConstants.SMS_REMINDER_TELEFONICA  },
    { label: "Twilio", value: providerConstants.SMS_TWILIO  },
],
SMS_REMINDER: [
    { label: "Bitsense", value:  providerConstants.SMS_REMINDER_BITSENSE },
    { label: "C3ntro", value: providerConstants.SMS_REMINDER_C3NTRO  },
    { label: "Davivienda", value: providerConstants.SMS_REMINDER_DAVIVIENDA  },
    { label: "Mobisa", value: providerConstants.SMS_REMINDER_MOBISA  },
    { label: "Movistar", value: providerConstants.SMS_REMINDER_MOVISTAR  },
    { label: "Supervielle", value:  providerConstants.SMS_REMINDER_SUPERVIELLE  },
    { label: "Telefónica", value: providerConstants.SMS_REMINDER_TELEFONICA  },
    { label: "Twilio", value: providerConstants.SMS_REMINDER_TWILIO  },
],
WHATSAPP: [
    { label: "Vonage", value: providerConstants.WHATSAPP_VONAGE  },
]
};





